export default { Loading: 'Läser in' };
